import { useState } from 'react';
import { Map as MapIcon } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { DeliveryAddressMap } from '~/components/common/DeliveryAddressMap';
import { hasCoordinates, type AddressLike } from '~/utils/addressFormat';

type Props = {
  address: AddressLike | null | undefined;
};

export function DeliveryAddressMapToggle({ address }: Readonly<Props>) {
  const { t } = useTranslation('general');
  const [visible, setVisible] = useState(false);

  if (!hasCoordinates(address)) return null;

  return (
    <div className="mt-2">
      <button
        type="button"
        data-testid="delivery-address-map-toggle"
        aria-expanded={visible}
        className="inline-flex items-center gap-1.5 text-xs font-medium text-prim-700 hover:text-prim-800"
        onClick={() => setVisible((shown) => !shown)}
      >
        <MapIcon className="w-3.5 h-3.5" />
        {visible
          ? t('delivery_address_map.hide')
          : t('delivery_address_map.show')}
      </button>
      {visible && (
        <div className="mt-2">
          <DeliveryAddressMap
            latitude={address.latitude}
            longitude={address.longitude}
          />
        </div>
      )}
    </div>
  );
}
